import { SVGIcon } from '@progress/kendo-svg-icons';
import React from 'react';
import styled from 'styled-components';

interface svgProps {
  color?: string;
  ascendingcolor?: string;
  descendingcolor?: string;
  width?: string;
  height?: string;
  strokeWidth?: string;
  stroke?: string;
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  tooltip?: string;
  isTrue?: boolean;
}
const SvgWrapper = styled('svg')({});

const ExportIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '17'}
      height={height ? height : '13'}
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2923 6.50004L13.459 3.66671V5.79171H7.08398V7.20837H13.459V9.33337M0.708984 10.75V2.25004C0.708984 1.87432 0.85824 1.51398 1.12392 1.24831C1.38959 0.982629 1.74993 0.833374 2.12565 0.833374H10.6257C11.0014 0.833374 11.3617 0.982629 11.6274 1.24831C11.8931 1.51398 12.0423 1.87432 12.0423 2.25004V4.37504H10.6257V2.25004H2.12565V10.75H10.6257V8.62504H12.0423V10.75C12.0423 11.1258 11.8931 11.4861 11.6274 11.7518C11.3617 12.0175 11.0014 12.1667 10.6257 12.1667H2.12565C1.74993 12.1667 1.38959 12.0175 1.12392 11.7518C0.85824 11.4861 0.708984 11.1258 0.708984 10.75Z"
        fill={color || 'black'}
      />
    </SvgWrapper>
  );
};
const PlusIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '10'}
      height={height ? height : '11'}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.71429 0.731176C5.71429 0.541367 5.63903 0.359333 5.50508 0.225119C5.37112 0.0909041 5.18944 0.0155029 5 0.0155029C4.81056 0.0155029 4.62888 0.0909041 4.49492 0.225119C4.36097 0.359333 4.28571 0.541367 4.28571 0.731176V4.30954H0.714286C0.524845 4.30954 0.343164 4.38494 0.20921 4.51915C0.075255 4.65337 0 4.8354 0 5.02521C0 5.21502 0.075255 5.39705 0.20921 5.53127C0.343164 5.66548 0.524845 5.74088 0.714286 5.74088H4.28571V9.31925C4.28571 9.50906 4.36097 9.69109 4.49492 9.8253C4.62888 9.95952 4.81056 10.0349 5 10.0349C5.18944 10.0349 5.37112 9.95952 5.50508 9.8253C5.63903 9.69109 5.71429 9.50906 5.71429 9.31925V5.74088H9.28571C9.47515 5.74088 9.65684 5.66548 9.79079 5.53127C9.92475 5.39705 10 5.21502 10 5.02521C10 4.8354 9.92475 4.65337 9.79079 4.51915C9.65684 4.38494 9.47515 4.30954 9.28571 4.30954H5.71429V0.731176Z"
        fill={color || '#209BFF'}
      />
    </SvgWrapper>
  );
};
const UploadIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '13'}
      height={height ? height : '13'}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6875 9.75V3.12812L3.575 5.24062L2.4375 4.0625L6.5 0L10.5625 4.0625L9.425 5.24062L7.3125 3.12812V9.75H5.6875ZM1.625 13C1.17813 13 0.795708 12.841 0.47775 12.5231C0.159792 12.2051 0.000541667 11.8224 0 11.375V8.9375H1.625V11.375H11.375V8.9375H13V11.375C13 11.8219 12.841 12.2046 12.5231 12.5231C12.2051 12.8416 11.8224 13.0005 11.375 13H1.625Z"
        fill={color || '#707070'}
      />
    </SvgWrapper>
  );
};
const ConvertIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '14'}
      height={height ? height : '11'}
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8.72492e-05C6.78912 -0.000762546 6.58175 0.00433623 6.37088 0.0268558C5.8135 0.0854917 5.26006 0.225708 4.73025 0.451753C4.72631 0.453453 4.72062 0.450054 4.71669 0.451753C2.63944 1.32152 1.3125 3.33426 1.3125 5.49741H0L1.96875 8.0468L3.9375 5.49741H2.625C2.625 3.84031 3.65881 2.28264 5.25 1.62022C6.87794 0.92169 8.82481 1.29433 10.0761 2.50996L11.0057 1.60705C9.93213 0.564351 8.47481 0.00646071 7 0.000512148V8.72492e-05ZM12.0312 2.94803L10.0625 5.49741H11.375C11.375 7.15451 10.3412 8.71219 8.75 9.3746C7.12206 10.0731 5.17519 9.7005 3.92394 8.48487L2.99425 9.38778C4.627 10.9735 7.13781 11.4519 9.26975 10.5431C9.27325 10.5414 9.27981 10.5448 9.28331 10.5431C11.3606 9.67331 12.6875 7.66057 12.6875 5.49741H14L12.0312 2.94803Z"
        fill={color ? color : 'white'}
      />
    </SvgWrapper>
  );
};
const FileIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '57'}
      height={height ? height : '57'}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_223_3671)">
        <rect
          x="6"
          y="2.49994"
          width="45"
          height="45"
          rx="12"
          fill={color ? color : '#E4D0FF'}
        />
      </g>
      <path
        d="M21.4464 17.8182H35.5089C35.6732 17.8181 35.8373 17.8285 36.0002 17.8494C35.945 17.4617 35.8118 17.0892 35.6088 16.7543C35.4057 16.4195 35.1369 16.1292 34.8186 15.9011C34.5003 15.6729 34.1391 15.5116 33.7568 15.4268C33.3745 15.342 32.9789 15.3356 32.594 15.4078L21.029 17.3822H21.0158C20.2898 17.521 19.6443 17.9318 19.2109 18.5305C19.8638 18.0662 20.6453 17.8171 21.4464 17.8182Z"
        fill="white"
      />
      <path
        d="M35.5098 18.8748H21.4473C20.7016 18.8756 19.9867 19.1722 19.4594 19.6995C18.9322 20.2267 18.6356 20.9416 18.6348 21.6873V30.1248C18.6356 30.8705 18.9322 31.5854 19.4594 32.1126C19.9867 32.6399 20.7016 32.9365 21.4473 32.9373H35.5098C36.2554 32.9365 36.9703 32.6399 37.4976 32.1126C38.0249 31.5854 38.3214 30.8705 38.3223 30.1248V21.6873C38.3214 20.9416 38.0249 20.2267 37.4976 19.6995C36.9703 19.1722 36.2554 18.8756 35.5098 18.8748ZM33.4224 27.3123C33.1442 27.3123 32.8723 27.2298 32.6411 27.0753C32.4098 26.9208 32.2296 26.7012 32.1232 26.4442C32.0167 26.1873 31.9889 25.9045 32.0431 25.6317C32.0974 25.3589 32.2313 25.1084 32.428 24.9117C32.6247 24.715 32.8752 24.5811 33.148 24.5268C33.4208 24.4726 33.7035 24.5004 33.9605 24.6069C34.2175 24.7133 34.4371 24.8935 34.5916 25.1248C34.7461 25.356 34.8286 25.6279 34.8286 25.9061C34.8286 26.279 34.6804 26.6367 34.4167 26.9004C34.153 27.1642 33.7953 27.3123 33.4224 27.3123Z"
        fill="white"
      />
      <path
        d="M18.6562 24.6514V20.2788C18.6562 19.3265 19.1836 17.73 21.0139 17.3841C22.5674 17.0928 24.1055 17.0928 24.1055 17.0928C24.1055 17.0928 25.1162 17.7959 24.2812 17.7959C23.4463 17.7959 23.4683 18.8726 24.2812 18.8726C25.0942 18.8726 24.2812 19.9053 24.2812 19.9053L21.0073 23.6187L18.6562 24.6514Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_223_3671"
          x="0.5"
          y="0.499939"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_223_3671"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_223_3671"
            result="shape"
          />
        </filter>
      </defs>
    </SvgWrapper>
  );
};
const DocumentIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '57'}
      height={height ? height : '57'}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_163_3194)">
        <rect
          x="6"
          y="2.49994"
          width="45"
          height="45"
          rx="12"
          fill={color ? color : '#A3C0FF'}
        />
      </g>
      <path
        d="M29.9062 23.6056H36.0585C36.102 23.6056 36.1438 23.6229 36.1745 23.6537C36.2053 23.6844 36.2226 23.7262 36.2226 23.7697V32.0314C36.2226 32.7742 35.9275 33.4866 35.4023 34.0118C34.877 34.5371 34.1646 34.8322 33.4218 34.8322H23.5781C22.8353 34.8322 22.1229 34.5371 21.5976 34.0118C21.0724 33.4866 20.7773 32.7742 20.7773 32.0314V17.9689C20.7773 17.2261 21.0724 16.5137 21.5976 15.9885C22.1229 15.4632 22.8353 15.1681 23.5781 15.1681H27.621C27.6645 15.1681 27.7063 15.1854 27.737 15.2162C27.7678 15.2469 27.7851 15.2887 27.7851 15.3322V21.4845C27.7851 22.0471 28.0086 22.5866 28.4063 22.9844C28.8041 23.3821 29.3436 23.6056 29.9062 23.6056ZM24.9843 30.6369H32.0156C32.2052 30.6369 32.387 30.5616 32.521 30.4275C32.6551 30.2934 32.7304 30.1116 32.7304 29.922C32.7304 29.7324 32.6551 29.5506 32.521 29.4166C32.387 29.2825 32.2052 29.2072 32.0156 29.2072H24.9843C24.7947 29.2072 24.6129 29.2825 24.4788 29.4166C24.3448 29.5506 24.2695 29.7324 24.2695 29.922C24.2695 30.1116 24.3448 30.2934 24.4788 30.4275C24.6129 30.5616 24.7947 30.6369 24.9843 30.6369ZM24.9843 27.1212H32.0156C32.2052 27.1212 32.387 27.0459 32.521 26.9119C32.6551 26.7778 32.7304 26.596 32.7304 26.4064C32.7304 26.2168 32.6551 26.035 32.521 25.9009C32.387 25.7669 32.2052 25.6916 32.0156 25.6916H24.9843C24.7947 25.6916 24.6129 25.7669 24.4788 25.9009C24.3448 26.035 24.2695 26.2168 24.2695 26.4064C24.2695 26.596 24.3448 26.7778 24.4788 26.9119C24.6129 27.0459 24.7947 27.1212 24.9843 27.1212Z"
        fill="white"
        stroke="#4FD1C5"
        stroke-width="0.0234375"
      />
      <path
        d="M29.3446 15.7274L35.6644 22.0472C35.6749 22.0578 35.6821 22.0714 35.6851 22.0861C35.688 22.1008 35.6865 22.1161 35.6807 22.13C35.675 22.1439 35.6653 22.1557 35.6528 22.1641C35.6403 22.1725 35.6257 22.177 35.6107 22.177H29.9062C29.7228 22.177 29.5469 22.1042 29.4173 21.9745C29.2876 21.8449 29.2148 21.669 29.2148 21.4856V15.7811C29.2148 15.7661 29.2193 15.7515 29.2277 15.739C29.2361 15.7265 29.2479 15.7168 29.2618 15.7111C29.2757 15.7053 29.291 15.7038 29.3057 15.7067C29.3204 15.7096 29.334 15.7168 29.3446 15.7274C29.3446 15.7274 29.3446 15.7274 29.3446 15.7274Z"
        fill="white"
        stroke="#4FD1C5"
        stroke-width="0.0234375"
      />
      <defs>
        <filter
          id="filter0_d_163_3194"
          x="0.5"
          y="0.499939"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_163_3194"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_163_3194"
            result="shape"
          />
        </filter>
      </defs>
    </SvgWrapper>
  );
};
const FileIconV2 = ({ className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width="25"
      height="45"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3462 5H3.65385C2.18817 5 1 6.19391 1 7.66667V18.3333C1 19.8061 2.18817 21 3.65385 21H21.3462C22.8118 21 24 19.8061 24 18.3333V7.66667C24 6.19391 22.8118 5 21.3462 5Z"
        stroke="#474747"
        stroke-linejoin="round"
      />
      <path
        d="M21 5.44405V3.77719C20.9999 3.36837 20.9104 2.96462 20.7378 2.59475C20.5653 2.22487 20.3141 1.89798 20.002 1.63741C19.6899 1.37684 19.3247 1.18901 18.9325 1.08732C18.5402 0.985627 18.1306 0.972581 17.7327 1.04911L3.2369 3.54661C2.6074 3.66771 2.03949 4.00676 1.63114 4.5053C1.22278 5.00383 0.999566 5.63059 1 6.27747V9"
        stroke="#474747"
        stroke-linejoin="round"
      />
      <path
        d="M19 15C18.6044 15 18.2178 14.8827 17.8889 14.6629C17.56 14.4432 17.3036 14.1308 17.1522 13.7654C17.0009 13.3999 16.9613 12.9978 17.0384 12.6098C17.1156 12.2219 17.3061 11.8655 17.5858 11.5858C17.8655 11.3061 18.2219 11.1156 18.6098 11.0384C18.9978 10.9613 19.3999 11.0009 19.7654 11.1522C20.1308 11.3036 20.4432 11.56 20.6629 11.8889C20.8827 12.2178 21 12.6044 21 13C21 13.5304 20.7893 14.0391 20.4142 14.4142C20.0391 14.7893 19.5304 15 19 15Z"
        fill="#474747"
      />
    </SvgWrapper>
  );
};
const DocumentIconV2 = ({ className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1667 22.75H24.0833M16.1667 25.9166H27.25M16.1667 29.0833H20.9167M32 30.6666V19.5833L24.0833 11.6666H16.1667C15.3268 11.6666 14.5214 12.0003 13.9275 12.5941C13.3336 13.188 13 13.9934 13 14.8333V30.6666C13 31.5065 13.3336 32.3119 13.9275 32.9058C14.5214 33.4997 15.3268 33.8333 16.1667 33.8333H28.8333C29.6732 33.8333 30.4786 33.4997 31.0725 32.9058C31.6664 32.3119 32 31.5065 32 30.6666Z"
        stroke="#474747"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0833 11.6666V16.4166C24.0833 17.2565 24.417 18.0619 25.0108 18.6558C25.6047 19.2497 26.4101 19.5833 27.25 19.5833H32"
        stroke="#474747"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{' '}
    </SvgWrapper>
  );
};
//CloseIcon
const CloseIcon = ({
  color,
  width,
  height,
  className,
  onClick,
  tooltip,
}: svgProps) => {
  return (
    <SvgWrapper
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '8.265'}
      height={height ? height : '8.265'}
      viewBox="0 0 8.265 8.265"
      fill="none"
    >
      {tooltip && <title>{tooltip}</title>}
      <g id="__TEMP__SVG__" transform="translate(-0.775 0.141)">
        <g
          id="Group_68374"
          data-name="Group 68374"
          transform="translate(0.189 0.703)"
        >
          <g id="close" transform="translate(1.27 -1.161)">
            <g
              id="Group_68381"
              data-name="Group 68381"
              transform="translate(1.054 1.054)"
            >
              <path
                id="Path_35977"
                data-name="Path 35977"
                d="M6.218,5.187,9.1,2.3A.73.73,0,0,0,8.072,1.268L5.187,4.154,2.3,1.268A.73.73,0,0,0,1.268,2.3L4.154,5.187,1.268,8.072A.73.73,0,0,0,2.3,9.1L5.187,6.219,8.072,9.1A.73.73,0,0,0,9.1,8.072Z"
                transform="translate(-2.792 -1.792)"
                fill={color ? color : '#A0AEC0'}
              />
            </g>
          </g>
        </g>
      </g>
    </SvgWrapper>
  );
};

const WarningIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '32'}
      height={height ? height : '30'}
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0724 19.0689C16.9569 19.0689 17.6739 18.3519 17.6739 17.4674L17.6739 10.0512C17.6739 9.16672 16.9569 8.44971 16.0724 8.44971C15.1879 8.44971 14.4709 9.16672 14.4709 10.0512V17.4428C14.4643 17.8717 14.6301 18.2855 14.9312 18.5911C15.2322 18.8968 15.6433 19.0689 16.0724 19.0689Z"
        fill="#252525"
      />
      <circle cx="16.011" cy="22.703" r="1.84789" fill="#252525" />
      <path
        d="M31.2617 24.2675L19.2627 2.16675C18.6156 0.977782 17.3703 0.237732 16.0166 0.237732C14.6629 0.237732 13.4176 0.977782 12.7705 2.16675L0.759225 24.2675C0.11947 25.4158 0.137813 26.8175 0.807397 27.9487C1.47698 29.0799 2.69702 29.7703 4.0115 29.7618H28.0094C29.3127 29.763 30.5203 29.0776 31.1875 27.958C31.8548 26.8384 31.8829 25.4502 31.2617 24.3044V24.2675ZM29.0688 26.6574C28.847 27.0315 28.4443 27.261 28.0094 27.261H4.0115C3.57583 27.2622 3.17192 27.0332 2.94925 26.6587C2.72659 26.2842 2.71828 25.82 2.92741 25.4378L14.9264 3.33707C15.1414 2.93864 15.5577 2.69028 16.0104 2.69028C16.4632 2.69028 16.8795 2.93864 17.0945 3.33707L29.0935 25.4378C29.3012 25.8201 29.2919 26.2837 29.0688 26.6574Z"
        fill="#252525"
      />
    </SvgWrapper>
  );
};

const ArrowRight = ({ className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8854 10.385L18.0963 14.5958C18.5936 15.0931 18.5936 15.9069 18.0963 16.4042L13.8854 20.615"
        stroke="#7C86A1"
        stroke-width="0.96875"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="15.5"
        cy="15.5"
        r="15.2232"
        transform="rotate(-180 15.5 15.5)"
        stroke="#7C86A1"
        stroke-width="0.553571"
      />
    </SvgWrapper>
  );
};

//Circle-dot-icon
const CircleDotIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '6'}
      height={height ? height : '7'}
      viewBox="0 0 6 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="3"
        cy="3.3027"
        rx="3"
        ry="3.00583"
        fill={color ?? '#323232'}
      />
    </SvgWrapper>
  );
};
//caret-icon
const CaretIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '8'}
      height={height ? height : '11'}
      viewBox="0 0 86 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.923065 8.82692L4.61537 5.07692L0.923065 1.32692L2.15383 0.0769196L7.07691 5.07692L2.15383 10.0769L0.923065 8.82692Z"
        fill={color ?? 'black'}
        fill-opacity="0.55"
      />
    </SvgWrapper>
  );
};

//caret-icon
const GridExpandIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '8'}
      height={height ? height : '11'}
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.923096 8.8269L4.6154 5.0769L0.923096 1.3269L2.15386 0.0769043L7.07694 5.0769L2.15386 10.0769L0.923096 8.8269Z"
        fill={color ?? 'black'}
        fill-opacity="0.55"
      />
    </SvgWrapper>
  );
};

//caret-icon
const GridSortIcon = ({
  color,
  width,
  height,
  className,
  onClick,
  ascendingcolor,
  descendingcolor,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '10'}
      height={height ? height : '13'}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1.875V12.5H7.25V3.75H9.75L6 0V1.875Z"
        fill={descendingcolor ? descendingcolor : '#A0AEC0'}
      />
      <path
        d="M2.5 8.75H0L3.75 12.5V0H2.5V8.75Z"
        fill={ascendingcolor ? ascendingcolor : '#A0AEC0'}
      />
    </SvgWrapper>
  );
};

//caret-icon
const GridToggleIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '5'}
      height={height ? height : '18'}
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7L4 4L1 1"
        stroke={color ? color : '#605E5E'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};

//NoDataFoundIcon
const NoDataFoundIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '220'}
      height={height ? height : '160'}
      viewBox="0 0 220 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="110" cy="80" r="80" fill="#EAECF0" />
      <circle cx="26" cy="20" r="8" fill="#F2F4F7" />
      <circle cx="198" cy="126" r="6" fill="#F2F4F7" />
      <circle cx="25" cy="138" r="10" fill="#F2F4F7" />
      <circle cx="210" cy="46" r="10" fill="#F2F4F7" />
      <circle cx="191" cy="11" r="7" fill="#F2F4F7" />
      <g filter="url(#filter0_dd_1445_72532)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M113.486 16C96.7495 16 81.9448 24.2701 72.9354 36.9466C69.9934 36.2528 66.9253 35.8857 63.7714 35.8857C41.8063 35.8857 24 53.692 24 75.6571C24 97.6223 41.8063 115.429 63.7714 115.429H163.2C182.42 115.429 198 99.8481 198 80.6286C198 61.4091 182.42 45.8286 163.2 45.8286C161.835 45.8286 160.488 45.9072 159.164 46.0601C151.546 28.3784 133.961 16 113.486 16Z"
          fill="#F9FAFB"
        />
        <circle
          cx="63.7714"
          cy="75.6572"
          r="39.7714"
          fill="url(#paint0_linear_1445_72532)"
        />
        <circle
          cx="113.486"
          cy="65.7143"
          r="49.7143"
          fill="url(#paint1_linear_1445_72532)"
        />
        <circle
          cx="163.2"
          cy="80.6281"
          r="34.8"
          fill="url(#paint2_linear_1445_72532)"
        />
      </g>
      <g filter="url(#filter1_b_1445_72532)">
        <rect
          x="82"
          y="84"
          width="56"
          height="56"
          rx="28"
          fill="#344054"
          fill-opacity="0.4"
        />
        <path
          d="M120.5 122.5L116.417 118.417M119.333 111.417C119.333 116.893 114.893 121.333 109.417 121.333C103.94 121.333 99.5 116.893 99.5 111.417C99.5 105.94 103.94 101.5 109.417 101.5C114.893 101.5 119.333 105.94 119.333 111.417Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1445_72532"
          x="4"
          y="16"
          width="214"
          height="139.429"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1445_72532"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1445_72532"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1445_72532"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1445_72532"
            result="effect2_dropShadow_1445_72532"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1445_72532"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_1445_72532"
          x="74"
          y="76"
          width="72"
          height="72"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1445_72532"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1445_72532"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1445_72532"
          x1="33.2326"
          y1="49.3796"
          x2="103.543"
          y2="115.429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D0D5DD" />
          <stop offset="0.350715" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1445_72532"
          x1="75.3122"
          y1="32.8673"
          x2="163.2"
          y2="115.428"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D0D5DD" />
          <stop offset="0.350715" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1445_72532"
          x1="136.479"
          y1="57.6353"
          x2="198"
          y2="115.428"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D0D5DD" />
          <stop offset="0.350715" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </SvgWrapper>
  );
};

//prev button for date range picker
const PrevArrowIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '9'}
      height={height ? height : '8'}
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.145426 4.38171C0.0522651 4.28362 -1.6824e-07 4.15111 -1.74277e-07 4.01301C-1.80313e-07 3.87492 0.0522651 3.74241 0.145426 3.64432L3.47923 0.166057C3.52501 0.114797 3.58022 0.0736826 3.64156 0.0451663C3.7029 0.01665 3.76912 0.00131734 3.83626 8.13715e-05C3.90341 -0.00115507 3.9701 0.0117315 4.03237 0.0379723C4.09464 0.0642131 4.1512 0.10327 4.19869 0.152814C4.24617 0.202357 4.28361 0.261372 4.30876 0.326338C4.33391 0.391304 4.34626 0.460888 4.34508 0.530943C4.34389 0.600997 4.32919 0.670085 4.30186 0.734085C4.27453 0.798085 4.23512 0.855685 4.18599 0.903449L1.70564 3.49128L8.49993 3.49127C8.63256 3.49127 8.75975 3.54624 8.85353 3.64409C8.94731 3.74193 9 3.87464 9 4.01301C9 4.15139 8.94731 4.28409 8.85353 4.38194C8.75975 4.47978 8.63256 4.53475 8.49993 4.53475L1.70564 4.53475L4.18599 7.12258C4.27432 7.22148 4.32241 7.3523 4.32013 7.48746C4.31784 7.62263 4.26536 7.75159 4.17374 7.84719C4.08212 7.94278 3.95851 7.99753 3.82896 7.99992C3.6994 8.0023 3.57402 7.95213 3.47923 7.85997L0.145426 4.38171Z"
        fill={color ?? 'black'}
      />
    </SvgWrapper>
  );
};
const NextArrowIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '9'}
      height={height ? height : '8'}
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.85457 4.57004C8.94773 4.47394 9 4.34412 9 4.20882C9 4.07353 8.94773 3.94371 8.85457 3.8476L5.52077 0.439844C5.47499 0.389623 5.41978 0.349342 5.35844 0.321403C5.2971 0.293465 5.23088 0.278443 5.16374 0.277232C5.09659 0.276021 5.0299 0.288647 4.96763 0.314355C4.90536 0.340064 4.8488 0.37833 4.80131 0.426869C4.75383 0.475408 4.71639 0.533227 4.69124 0.596876C4.66609 0.660525 4.65374 0.728699 4.65492 0.797333C4.65611 0.865967 4.67081 0.933655 4.69814 0.996357C4.72547 1.05906 4.76488 1.11549 4.81401 1.16229L7.29436 3.69766L0.500071 3.69766C0.367444 3.69766 0.240249 3.75151 0.146467 3.84738C0.0526859 3.94324 1.80325e-07 4.07325 1.74277e-07 4.20882C1.68228e-07 4.34439 0.0526859 4.47441 0.146467 4.57027C0.240249 4.66613 0.367444 4.71998 0.500071 4.71998L7.29436 4.71999L4.81401 7.25536C4.72568 7.35225 4.67759 7.48042 4.67987 7.61284C4.68216 7.74527 4.73464 7.87162 4.82626 7.96527C4.91788 8.05893 5.04149 8.11257 5.17104 8.11491C5.3006 8.11725 5.42598 8.06809 5.52077 7.9778L8.85457 4.57004Z"
        fill={color ?? 'black'}
      />
    </SvgWrapper>
  );
};

const DropdownArrowIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '10'}
      height={height ? height : '10'}
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1.22756L4 4.16675L7 1.22756ZM4 4.16675L1 1.22756L4 4.16675Z"
        fill="#707070"
      />
      <path
        d="M7 1.22756L4 4.16675L1 1.22756"
        stroke="#707070"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};

const DropdownCloseIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '11'}
      height={height ? height : '10'}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L9.96 1M9.96 9L1 1"
        stroke={color ?? 'white'}
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};
const BackIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '15'}
      height={height ? height : '14'}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13L1 7L7 1M1.83333 7H14"
        stroke={color ? color : 'black'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};

const EditIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '22'}
      height={height ? height : '22'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="21" height="21" rx="4.5" stroke="#DBDBDB" />
      <path
        d="M13.5 5L15.375 6.80108L13.9456 8.17471L12.0706 6.37362L13.5 5ZM6 12.1971V13.9982H7.875L13.0619 9.02301L11.1869 7.22193L6 12.1971ZM6 15.7993H16V17H6V15.7993Z"
        fill={color ? color : '#727272'}
      />
    </SvgWrapper>
  );
};
const DeleteIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '22'}
      height={height ? height : '22'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="4.5"
        fill="#FFF1F1"
        stroke="#FFD8D8"
      />
      <path
        d="M6.71429 15.6667C6.71429 16.4 7.35714 17 8.14286 17H13.8571C14.6429 17 15.2857 16.4 15.2857 15.6667V9C15.2857 8.26667 14.6429 7.66667 13.8571 7.66667H8.14286C7.35714 7.66667 6.71429 8.26667 6.71429 9V15.6667ZM15.2857 5.66667H13.5L12.9929 5.19333C12.8643 5.07333 12.6786 5 12.4929 5H9.50714C9.32143 5 9.13571 5.07333 9.00714 5.19333L8.5 5.66667H6.71429C6.32143 5.66667 6 5.96667 6 6.33333C6 6.7 6.32143 7 6.71429 7H15.2857C15.6786 7 16 6.7 16 6.33333C16 5.96667 15.6786 5.66667 15.2857 5.66667Z"
        fill={color ? color : '#ED3A3A'}
      />
    </SvgWrapper>
  );
};
const WordIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '16'}
      height={height ? height : '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4029 1.5H4.85236C4.77405 1.49981 4.69648 1.51507 4.62409 1.54491C4.55169 1.57476 4.4859 1.6186 4.43048 1.67392C4.37507 1.72924 4.33112 1.79496 4.30115 1.86731C4.27118 1.93965 4.25579 2.0172 4.25586 2.0955V4.75L9.79036 6.375L14.9999 4.75V2.0955C14.9999 2.01716 14.9845 1.93957 14.9545 1.86719C14.9245 1.79481 14.8805 1.72907 14.8251 1.67374C14.7696 1.61841 14.7037 1.57458 14.6313 1.54477C14.5588 1.51495 14.4812 1.49974 14.4029 1.5Z"
        fill="#41A5EE"
      />
      <path
        d="M14.9999 4.75H4.25586V8L9.79036 8.975L14.9999 8V4.75Z"
        fill="#2B7CD3"
      />
      <path
        d="M4.25586 8V11.25L9.46486 11.9L14.9999 11.25V8H4.25586Z"
        fill="#185ABD"
      />
      <path
        d="M4.85236 14.5H14.4024C14.4807 14.5003 14.5584 14.4852 14.6309 14.4554C14.7034 14.4256 14.7694 14.3818 14.8249 14.3264C14.8804 14.2711 14.9244 14.2053 14.9545 14.1329C14.9845 14.0605 14.9999 13.9829 14.9999 13.9045V11.25H4.25586V13.9045C4.25579 13.9828 4.27118 14.0604 4.30115 14.1327C4.33112 14.205 4.37507 14.2708 4.43048 14.3261C4.4859 14.3814 4.55169 14.4252 4.62409 14.4551C4.69648 14.4849 4.77405 14.5002 4.85236 14.5Z"
        fill="#103F91"
      />
      <path
        opacity="0.1"
        d="M8.21686 4.10001H4.25586V12.225H8.21686C8.37469 12.2242 8.52586 12.1613 8.63761 12.0498C8.74935 11.9383 8.81268 11.7873 8.81386 11.6295V4.69551C8.81268 4.53768 8.74935 4.38667 8.63761 4.2752C8.52586 4.16374 8.37469 4.10079 8.21686 4.10001Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.89136 4.42499H4.25586V12.55H7.89136C8.04919 12.5492 8.20036 12.4863 8.31211 12.3748C8.42385 12.2633 8.48718 12.1123 8.48836 11.9545V5.02049C8.48718 4.86266 8.42385 4.71165 8.31211 4.60018C8.20036 4.48872 8.04919 4.42577 7.89136 4.42499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.89136 4.42499H4.25586V11.9H7.89136C8.04919 11.8992 8.20036 11.8363 8.31211 11.7248C8.42385 11.6133 8.48718 11.4623 8.48836 11.3045V5.02049C8.48718 4.86266 8.42385 4.71165 8.31211 4.60018C8.20036 4.48872 8.04919 4.42577 7.89136 4.42499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.56586 4.42499H4.25586V11.9H7.56586C7.72369 11.8992 7.87486 11.8363 7.98661 11.7248C8.09835 11.6133 8.16168 11.4623 8.16286 11.3045V5.02049C8.16168 4.86266 8.09835 4.71165 7.98661 4.60018C7.87486 4.48872 7.72369 4.42577 7.56586 4.42499Z"
        fill="black"
      />
      <path
        d="M1.597 4.42499H7.566C7.72411 4.42486 7.87581 4.48751 7.98776 4.59917C8.0997 4.71083 8.16273 4.86238 8.163 5.02049V10.9795C8.16273 11.1376 8.0997 11.2891 7.98776 11.4008C7.87581 11.5125 7.72411 11.5751 7.566 11.575H1.597C1.51865 11.5753 1.44103 11.56 1.36857 11.5302C1.29612 11.5004 1.23027 11.4566 1.1748 11.4013C1.11933 11.3459 1.07534 11.2802 1.04534 11.2078C1.01534 11.1354 0.999934 11.0578 1 10.9795V5.02049C0.999934 4.94214 1.01534 4.86455 1.04534 4.79218C1.07534 4.7198 1.11933 4.65406 1.1748 4.59873C1.23027 4.5434 1.29612 4.49957 1.36857 4.46975C1.44103 4.43994 1.51865 4.42473 1.597 4.42499Z"
        fill="url(#paint0_linear_280_5258)"
      />
      <path
        d="M3.4507 8.994C3.46237 9.086 3.47004 9.16616 3.4737 9.2345H3.4877C3.4927 9.1695 3.50354 9.09116 3.5202 8.9995C3.5452 8.862 3.5512 8.8305 3.5647 8.767L4.1922 6.0635H5.0042L5.6542 8.7265C5.69174 8.89129 5.71879 9.05829 5.7352 9.2265H5.7462C5.75868 9.06277 5.78122 8.89996 5.8137 8.739L6.3332 6.06H7.0717L6.1597 9.934H5.2962L4.6777 7.371C4.6597 7.297 4.63937 7.20066 4.6167 7.082C4.59404 6.96333 4.58004 6.87666 4.5747 6.822H4.5642C4.5572 6.885 4.5432 6.9785 4.5222 7.1025C4.5012 7.2265 4.48454 7.3185 4.4722 7.3785L3.8907 9.9355H3.0127L2.0957 6.0635H2.8457L3.4112 8.7725C3.42769 8.8457 3.44087 8.91961 3.4507 8.994Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_280_5258"
          x1="2.247"
          y1="3.95699"
          x2="6.916"
          y2="12.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2368C4" />
          <stop offset="0.5" stop-color="#1A5DBE" />
          <stop offset="1" stop-color="#1146AC" />
        </linearGradient>
      </defs>
    </SvgWrapper>
  );
};
const PdfIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '18'}
      height={height ? height : '18'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.556 1.1655L16.6857 4.428V16.8345H4.99414V16.875H16.7256V4.46906L13.556 1.1655Z"
        fill="#909090"
      />
      <path
        d="M13.518 1.125H4.95508V16.8345H16.6866V4.42856L13.518 1.125Z"
        fill="#F4F4F4"
      />
      <path
        d="M4.86781 1.96875H1.27344V5.80894H12.5797V1.96875H4.86781Z"
        fill="#7A7B7C"
      />
      <path d="M12.641 5.7437H1.34766V1.9007H12.641V5.7437Z" fill="#DD2025" />
      <path
        d="M5.09261 2.55038H4.35742V5.25038H4.93567V4.33969L5.06336 4.347C5.18747 4.34529 5.31045 4.32305 5.4273 4.28119C5.53002 4.24631 5.62443 4.19058 5.70461 4.1175C5.78683 4.04856 5.85142 3.96102 5.89305 3.86213C5.95 3.69828 5.97016 3.5239 5.95211 3.35138C5.9489 3.22811 5.92729 3.10601 5.88798 2.98913C5.85256 2.90464 5.7999 2.82849 5.73336 2.76553C5.66681 2.70257 5.58786 2.65419 5.50155 2.6235C5.42714 2.59594 5.35002 2.57633 5.27148 2.565C5.21216 2.55534 5.15215 2.55045 5.09205 2.55038M4.98573 3.84075H4.93567V3.00825H5.04423C5.09215 3.0048 5.14023 3.01215 5.18492 3.02977C5.2296 3.0474 5.26976 3.07483 5.30242 3.11006C5.3701 3.20063 5.40626 3.31088 5.40536 3.42394C5.40536 3.56231 5.40536 3.68775 5.28048 3.77606C5.19054 3.8256 5.08813 3.84845 4.98573 3.84075ZM7.05067 2.54306C6.98823 2.54306 6.92748 2.54756 6.88473 2.54925L6.75086 2.55263H6.31211V5.25263H6.82848C7.0258 5.2577 7.22221 5.22426 7.40673 5.15419C7.5553 5.09552 7.6868 5.00056 7.78923 4.878C7.88961 4.7549 7.96129 4.61097 7.99905 4.45669C8.04341 4.28227 8.06497 4.10284 8.06317 3.92288C8.07418 3.71034 8.05773 3.49727 8.01423 3.28894C7.97259 3.13576 7.89552 2.99453 7.78923 2.87663C7.70587 2.78129 7.60332 2.70462 7.4883 2.65163C7.38976 2.60595 7.28607 2.57233 7.17948 2.5515C7.1371 2.54455 7.09418 2.54135 7.05123 2.54194M6.94886 4.7565H6.89261V3.033H6.89992C7.01589 3.01959 7.13324 3.04052 7.23742 3.09319C7.31373 3.15412 7.37591 3.23089 7.41967 3.31819C7.4669 3.41006 7.49412 3.5109 7.49955 3.61406C7.50461 3.73781 7.49955 3.83906 7.49955 3.92288C7.50163 4.01942 7.49542 4.11596 7.48098 4.21144C7.46329 4.30935 7.43126 4.40412 7.38592 4.49269C7.33471 4.57529 7.26476 4.64466 7.18173 4.69519C7.11239 4.74019 7.03016 4.76114 6.94773 4.75481M9.80523 2.55263H8.43836V5.25263H9.01661V4.18163H9.74786V3.67988H9.01661V3.05438H9.80411V2.55263"
        fill="#464648"
      />
      <path
        d="M12.2514 11.3934C12.2514 11.3934 14.0446 11.0683 14.0446 11.6809C14.0446 12.2934 12.9337 12.0443 12.2514 11.3934ZM10.9256 11.4401C10.6406 11.5029 10.363 11.5951 10.097 11.7152L10.322 11.2089C10.547 10.7027 10.7805 10.0125 10.7805 10.0125C11.0483 10.4648 11.3607 10.8892 11.7131 11.2793C11.4478 11.3188 11.1849 11.3729 10.9256 11.4413V11.4401ZM10.2157 7.78388C10.2157 7.25007 10.3884 7.10438 10.5228 7.10438C10.6573 7.10438 10.8086 7.16907 10.8136 7.63257C10.7698 8.09862 10.6722 8.55805 10.5228 9.00169C10.3175 8.62947 10.2116 8.21064 10.2151 7.78557L10.2157 7.78388ZM7.60064 13.6991C7.05052 13.3701 8.75433 12.357 9.06315 12.3244C9.06146 12.3249 8.17664 14.0434 7.60064 13.6991ZM14.5683 11.7534C14.5627 11.6972 14.5121 11.0745 13.404 11.1009C12.9421 11.0928 12.4803 11.1254 12.0241 11.1983C11.582 10.7532 11.2013 10.2509 10.8924 9.70482C11.0869 9.14192 11.2048 8.55541 11.2428 7.96107C11.2265 7.28607 11.0651 6.89907 10.5476 6.90469C10.0301 6.91032 9.95471 7.36313 10.0228 8.03701C10.0894 8.48986 10.2151 8.93201 10.3968 9.35213C10.3968 9.35213 10.1578 10.0963 9.84164 10.8366C9.52552 11.5768 9.30952 11.9649 9.30952 11.9649C8.75972 12.1437 8.2422 12.4096 7.77671 12.7524C7.31321 13.1839 7.12477 13.5152 7.36889 13.8465C7.57927 14.1323 8.31558 14.1969 8.97371 13.3346C9.32279 12.8888 9.64223 12.4206 9.92996 11.9329C9.92996 11.9329 10.9335 11.6578 11.2456 11.5824C11.5578 11.5071 11.9353 11.4474 11.9353 11.4474C11.9353 11.4474 12.8516 12.3694 13.7353 12.3368C14.619 12.3041 14.5762 11.8086 14.5706 11.7546"
        fill="#DD2025"
      />
      <path
        d="M13.4746 1.1683V4.47187H16.6432L13.4746 1.1683Z"
        fill="#909090"
      />
      <path d="M13.5176 1.125V4.42856H16.6861L13.5176 1.125Z" fill="#F4F4F4" />
      <path
        d="M5.04769 2.50707H4.3125V5.20707H4.893V4.29695L5.02125 4.30426C5.14536 4.30255 5.26834 4.28031 5.38519 4.23845C5.48791 4.20357 5.58232 4.14784 5.6625 4.07476C5.7441 4.00563 5.80811 3.9181 5.84925 3.81938C5.9062 3.65554 5.92636 3.48116 5.90831 3.30863C5.90511 3.18536 5.88349 3.06326 5.84419 2.94638C5.80877 2.8619 5.7561 2.78574 5.68956 2.72278C5.62302 2.65983 5.54406 2.61145 5.45775 2.58076C5.383 2.55293 5.3055 2.53313 5.22656 2.5217C5.16724 2.51204 5.10723 2.50714 5.04712 2.50707M4.94081 3.79745H4.89075V2.96495H4.99988C5.04779 2.96149 5.09587 2.96885 5.14056 2.98647C5.18524 3.00409 5.2254 3.03153 5.25806 3.06676C5.32574 3.15733 5.3619 3.26757 5.361 3.38063C5.361 3.51901 5.361 3.64445 5.23613 3.73276C5.14619 3.7823 5.04377 3.80458 4.94138 3.79688M7.00575 2.49976C6.94331 2.49976 6.88256 2.50426 6.83981 2.50595L6.70762 2.50932H6.26887V5.20932H6.78525C6.98257 5.2144 7.17898 5.18096 7.3635 5.11088C7.51207 5.05221 7.64357 4.95726 7.746 4.8347C7.84638 4.71159 7.91805 4.56767 7.95581 4.41338C8.00018 4.23897 8.02173 4.05953 8.01994 3.87957C8.03095 3.66703 8.0145 3.45396 7.971 3.24563C7.92936 3.09246 7.85228 2.95122 7.746 2.83332C7.66264 2.73798 7.56009 2.66131 7.44506 2.60832C7.34653 2.56265 7.24284 2.52903 7.13625 2.5082C7.09386 2.50125 7.05095 2.49805 7.008 2.49863M6.90562 4.7132H6.84938V2.9897H6.85669C6.97265 2.97629 7.09001 2.99721 7.19419 3.04988C7.2705 3.11082 7.33268 3.18758 7.37644 3.27488C7.42366 3.36676 7.45089 3.4676 7.45631 3.57076C7.46137 3.69451 7.45631 3.79576 7.45631 3.87957C7.45839 3.97611 7.45218 4.07265 7.43775 4.16813C7.42005 4.26605 7.38802 4.36081 7.34269 4.44938C7.29147 4.53198 7.22152 4.60136 7.1385 4.65188C7.06915 4.69689 6.98693 4.71784 6.9045 4.71151M9.76031 2.50932H8.39344V5.20932H8.97169V4.13832H9.70294V3.63657H8.97169V3.01107H9.75919V2.50932"
        fill="white"
      />
    </SvgWrapper>
  );
};
const ExcelIcon = ({ color, width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '16'}
      height={height ? height : '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.79036 7.67501L4.25586 6.70001V13.9045C4.25579 13.9828 4.27118 14.0604 4.30115 14.1327C4.33112 14.2051 4.37507 14.2708 4.43048 14.3261C4.4859 14.3814 4.55169 14.4253 4.62409 14.4551C4.69648 14.4849 4.77405 14.5002 4.85236 14.5H14.4024C14.4807 14.5003 14.5584 14.4852 14.6309 14.4554C14.7034 14.4256 14.7694 14.3818 14.8249 14.3265C14.8804 14.2711 14.9244 14.2054 14.9545 14.1329C14.9845 14.0605 14.9999 13.9829 14.9999 13.9045V11.25L9.79036 7.67501Z"
        fill="#185C37"
      />
      <path
        d="M9.79036 1.5H4.85236C4.77405 1.4998 4.69648 1.51507 4.62409 1.54491C4.55169 1.57475 4.4859 1.6186 4.43048 1.67392C4.37507 1.72924 4.33112 1.79496 4.30115 1.8673C4.27118 1.93965 4.25579 2.0172 4.25586 2.0955V4.75L9.79036 8L12.7209 8.975L14.9999 8V4.75L9.79036 1.5Z"
        fill="#21A366"
      />
      <path d="M4.25586 4.75H9.79036V8H4.25586V4.75Z" fill="#107C41" />
      <path
        opacity="0.1"
        d="M8.21686 4.10001H4.25586V12.225H8.21686C8.37469 12.2242 8.52586 12.1613 8.63761 12.0498C8.74935 11.9383 8.81268 11.7873 8.81386 11.6295V4.69551C8.81268 4.53768 8.74935 4.38667 8.63761 4.2752C8.52586 4.16374 8.37469 4.10079 8.21686 4.10001Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.89136 4.42499H4.25586V12.55H7.89136C8.04919 12.5492 8.20036 12.4863 8.31211 12.3748C8.42385 12.2633 8.48718 12.1123 8.48836 11.9545V5.02049C8.48718 4.86266 8.42385 4.71165 8.31211 4.60018C8.20036 4.48872 8.04919 4.42577 7.89136 4.42499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.89136 4.42499H4.25586V11.9H7.89136C8.04919 11.8992 8.20036 11.8363 8.31211 11.7248C8.42385 11.6133 8.48718 11.4623 8.48836 11.3045V5.02049C8.48718 4.86266 8.42385 4.71165 8.31211 4.60018C8.20036 4.48872 8.04919 4.42577 7.89136 4.42499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M7.56586 4.42499H4.25586V11.9H7.56586C7.72369 11.8992 7.87486 11.8363 7.98661 11.7248C8.09835 11.6133 8.16168 11.4623 8.16286 11.3045V5.02049C8.16168 4.86266 8.09835 4.71165 7.98661 4.60018C7.87486 4.48872 7.72369 4.42577 7.56586 4.42499Z"
        fill="black"
      />
      <path
        d="M1.597 4.42499H7.566C7.72411 4.42486 7.87581 4.48751 7.98776 4.59917C8.0997 4.71083 8.16273 4.86238 8.163 5.02049V10.9795C8.16273 11.1376 8.0997 11.2891 7.98776 11.4008C7.87581 11.5125 7.72411 11.5751 7.566 11.575H1.597C1.51865 11.5753 1.44103 11.56 1.36857 11.5302C1.29612 11.5004 1.23027 11.4566 1.1748 11.4013C1.11933 11.3459 1.07534 11.2802 1.04534 11.2078C1.01534 11.1354 0.999934 11.0578 1 10.9795V5.02049C0.999934 4.94214 1.01534 4.86455 1.04534 4.79218C1.07534 4.7198 1.11933 4.65406 1.1748 4.59873C1.23027 4.5434 1.29612 4.49957 1.36857 4.46975C1.44103 4.43994 1.51865 4.42473 1.597 4.42499Z"
        fill="url(#paint0_linear_280_5222)"
      />
      <path
        d="M2.84961 9.93651L4.10511 7.99451L2.95511 6.06351H3.87861L4.50611 7.30001C4.56411 7.41701 4.60611 7.50401 4.62511 7.56201H4.63361C4.67461 7.46834 4.71794 7.37734 4.76361 7.28901L5.43461 6.06551H6.28461L5.10511 7.98551L6.31461 9.93801H5.41011L4.68511 8.58251C4.65154 8.52418 4.62294 8.46313 4.59961 8.40001H4.58761C4.56642 8.46153 4.53823 8.52041 4.50361 8.57551L3.75711 9.93651H2.84961Z"
        fill="white"
      />
      <path
        d="M14.4035 1.5H9.79102V4.75H15.0005V2.0955C15.0006 2.01716 14.9852 1.93957 14.9552 1.86719C14.9252 1.79481 14.8812 1.72907 14.8257 1.67374C14.7702 1.61841 14.7044 1.57458 14.6319 1.54477C14.5595 1.51495 14.4819 1.49974 14.4035 1.5Z"
        fill="#33C481"
      />
      <path d="M9.79102 8H15.0005V11.25H9.79102V8Z" fill="#107C41" />
      <defs>
        <linearGradient
          id="paint0_linear_280_5222"
          x1="2.247"
          y1="3.95699"
          x2="6.916"
          y2="12.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#18884F" />
          <stop offset="0.5" stop-color="#117E43" />
          <stop offset="1" stop-color="#0B6631" />
        </linearGradient>
      </defs>
    </SvgWrapper>
  );
};
const MobileBackIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '9'}
      height={height ? height : '18'}
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.37783 0.21967C8.67072 0.512563 8.67072 0.987437 8.37783 1.28033L1.85783 7.80033C1.38072 8.27744 1.38072 9.06256 1.85783 9.53967L8.37783 16.0597C8.67072 16.3526 8.67072 16.8274 8.37783 17.1203C8.08494 17.4132 7.61006 17.4132 7.31717 17.1203L0.79717 10.6003C-0.265723 9.53744 -0.265723 7.80256 0.79717 6.73967L7.31717 0.21967C7.61006 -0.0732233 8.08494 -0.0732233 8.37783 0.21967Z"
        fill="#101317"
      />
    </SvgWrapper>
  );
};

const FloatingButtonIcon: SVGIcon = {
  name: 'floating-button-icon',
  content: `
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.1825 7.66591C20.2258 8.31992 20.1716 9.05971 20.0416 9.88527L19.2508 14.9137C18.5791 19.1058 16.6183 20.521 12.3825 19.867L7.30162 19.0736C5.83912 18.8484 4.71245 18.4625 3.88912 17.8835C2.31828 16.8006 1.86328 15.0209 2.29662 12.2762L3.09828 7.24777C3.76995 3.05566 5.73078 1.64042 9.96662 2.29444L15.0475 3.08783C18.4491 3.61318 20.0416 4.98554 20.1825 7.66591Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M22.2083 14.4419L20.5833 19.2773C19.2292 23.3086 17.0625 24.3807 12.9892 23.0405L8.10333 21.4323C5.64416 20.6282 4.27916 19.5132 3.88916 17.8835C4.71249 18.4625 5.83916 18.8484 7.30166 19.0736L12.3825 19.867C16.6183 20.521 18.5792 19.1057 19.2508 14.9136L20.0417 9.88525C20.1717 9.05969 20.2258 8.31991 20.1825 7.66589C22.7717 9.02753 23.335 11.0861 22.2083 14.4419Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.92663 9.62794C9.96768 9.62794 10.8116 8.7927 10.8116 7.76239C10.8116 6.73208 9.96768 5.89685 8.92663 5.89685C7.88557 5.89685 7.04163 6.73208 7.04163 7.76239C7.04163 8.7927 7.88557 9.62794 8.92663 9.62794Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  viewBox: '0 0 26 26',
};
//history dot icon
const HistoryDotIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '16'}
      height={height ? height : '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="6" r="6" fill="#DFDFDF" />
      <g filter="url(#filter0_d_4002_9629)">
        <circle cx="8" cy="6" r="3.5" fill="black" />
      </g>
      <defs>
        <filter
          id="filter0_d_4002_9629"
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4002_9629"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4002_9629"
            result="shape"
          />
        </filter>
      </defs>
    </SvgWrapper>
  );
};

const RightCaretArrow = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '9'}
      height={height ? height : '14'}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.65674 1.00001L7.31359 6.65687L1.65674 12.3137"
        stroke={color ?? '#848A9C'}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </SvgWrapper>
  );
};

const FileUploadTypeIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '20'}
      height={height ? height : '23'}
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="20"
        height="23"
        rx="1"
        transform="matrix(1 0 0 -1 0 23)"
        fill="#D9D9D9"
      />
      <path
        d="M14.1667 10.2857H10.8333V6.85714H5.83333V17.1429H14.1667V10.2857ZM13.8217 9.42857L11.6667 7.212V9.42857H13.8217ZM5.41667 6H11.6667L15 9.42857V17.5714C15 17.6851 14.9561 17.7941 14.878 17.8745C14.7998 17.9548 14.6938 18 14.5833 18H5.41667C5.30616 18 5.20018 17.9548 5.12204 17.8745C5.0439 17.7941 5 17.6851 5 17.5714V6.42857C5 6.31491 5.0439 6.2059 5.12204 6.12553C5.20018 6.04515 5.30616 6 5.41667 6ZM7.5 12H12.5V12.8571H7.5V12ZM7.5 9.42857H9.58333V10.2857H7.5V9.42857ZM7.5 14.5714H12.5V15.4286H7.5V14.5714Z"
        fill="black"
        fill-opacity="0.49"
      />
    </SvgWrapper>
  );
};
const RedWarningIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '31'}
      height={height ? height : '31'}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6156 5.11112C17.4054 4.73515 17.0987 4.42206 16.7271 4.20413C16.3555 3.9862 15.9326 3.87131 15.5018 3.87131C15.071 3.87131 14.6481 3.9862 14.2765 4.20413C13.9049 4.42206 13.5982 4.73515 13.388 5.11112L4.17905 21.5837C3.97306 21.9522 3.86694 22.3681 3.87122 22.7902C3.8755 23.2123 3.99003 23.6259 4.20345 23.9901C4.41688 24.3543 4.72179 24.6564 5.08795 24.8664C5.45411 25.0765 5.8688 25.1871 6.29093 25.1875H24.7049C25.1272 25.1875 25.5422 25.077 25.9086 24.8671C26.275 24.6573 26.5802 24.3552 26.7938 23.991C27.0075 23.6267 27.1222 23.2129 27.1266 22.7907C27.1309 22.3684 27.0248 21.9523 26.8187 21.5837L17.6156 5.11112ZM16.953 19.8594C16.953 20.2448 16.7999 20.6144 16.5274 20.8869C16.2549 21.1594 15.8853 21.3125 15.4999 21.3125C15.1145 21.3125 14.7449 21.1594 14.4723 20.8869C14.1998 20.6144 14.0467 20.2448 14.0467 19.8594C14.0467 19.474 14.1998 19.1044 14.4723 18.8319C14.7449 18.5593 15.1145 18.4062 15.4999 18.4062C15.8853 18.4062 16.2549 18.5593 16.5274 18.8319C16.7999 19.1044 16.953 19.474 16.953 19.8594ZM14.5311 15.5V10.6562C14.5311 10.3993 14.6332 10.1529 14.8149 9.97123C14.9965 9.78956 15.2429 9.68749 15.4999 9.68749C15.7568 9.68749 16.0032 9.78956 16.1849 9.97123C16.3666 10.1529 16.4686 10.3993 16.4686 10.6562V15.5C16.4686 15.7569 16.3666 16.0033 16.1849 16.185C16.0032 16.3667 15.7568 16.4687 15.4999 16.4687C15.2429 16.4687 14.9965 16.3667 14.8149 16.185C14.6332 16.0033 14.5311 15.7569 14.5311 15.5Z"
        fill="#FF0A0A"
      />
    </SvgWrapper>
  );
};

const RightCaretIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '9'}
      height={height ? height : '14'}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.65686 1.00001L7.31371 6.65687L1.65686 12.3137"
        stroke={color ?? '#848A9C'}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </SvgWrapper>
  );
};

const WarningCloseIcon = ({ className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.9 9L0 8.1L3.6 4.5L0 0.9L0.9 0L4.5 3.6L8.1 0L9 0.9L5.4 4.5L9 8.1L8.1 9L4.5 5.4L0.9 9Z"
        fill="black"
      />
    </SvgWrapper>
  );
};

const SplitMoreIcon = ({
  color,
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '15'}
      height={height ? height : '15'}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.5625 6.5625V0H8.4375V6.5625H15V8.4375H8.4375V15H6.5625V8.4375H0V6.5625H6.5625Z"
        fill={color || 'black'}
      />
    </SvgWrapper>
  );
};

const SplitMoreMobileIcon = ({
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '27'}
      height={height ? height : '25'}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="26"
        height="24"
        rx="3.5"
        fill="#F8FBFF"
        stroke="#E2E8F0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13 12V5H15V12H22V14H15V21H13V14H6V12H13Z"
        fill="black"
        fill-opacity="0.42"
      />
    </SvgWrapper>
  );
};

const SplitRemoveMobileIcon = ({
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '27'}
      height={height ? height : '25'}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="26"
        height="24"
        rx="3.5"
        fill="#F8FBFF"
        stroke="#E2E8F0"
      />
      <path d="M22 14H6V12H22V14Z" fill="black" fill-opacity="0.42" />
    </SvgWrapper>
  );
};

const BankIcon = ({
  color,
  width,
  height,
  className,
  onClick,
  mobileActive,
}: svgProps & {
  mobileActive?: boolean;
}) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '19'}
      height={height ? height : '20'}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 9H2.5V16H4.5V9ZM10.5 9H8.5V16H10.5V9ZM19 18H0V20H19V18ZM16.5 9H14.5V16H16.5V9ZM9.5 2.26L14.71 5H4.29L9.5 2.26ZM9.5 0L0 5V7H19V5L9.5 0Z"
        fill={color ?? '#474747'}
      />
    </SvgWrapper>
  );
};
const SublimitTypeIcon = ({
  width,
  height,
  className,
  mobileActive,
  onClick,
}: svgProps & {
  mobileActive?: boolean;
}) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {mobileActive ? (
        <>
          <path
            d="M3 12V15.5H7M7 12H19V19H7V12ZM1 4.75V4.25V4.75ZM1 8V7.5V8ZM1 1.5V1V1.5ZM14 4.75V4.25V4.75ZM14 8V7.5V8ZM14 1.5V1V1.5ZM14 8H13.5H14ZM1.5 8H1H1.5ZM1.5 1H1H1.5ZM4.5 1H4H4.5ZM7.75 1H7.25H7.75ZM7.75 8H7.25H7.75ZM11 1H10.5H11ZM4.5 8H4H4.5ZM11 8H10.5H11ZM14 1H13.5H14Z"
            fill="#D9D9D9"
          />
          <path
            d="M3 12V15.5H7M1 4.75V4.25M1 7.5V8H1.5M1 1.5V1H1.5M14 4.75V4.25M14 7.5V8H13.5M14 1.5V1H13.5M4.5 1H4M7.75 1H7.25M7.75 8H7.25M11 1H10.5M4.5 8H4M11 8H10.5M7 12H19V19H7V12Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      ) : (
        <>
          <path
            d="M3 12V15.5H7M7 12H19V19H7V12ZM1 4.75V4.25V4.75ZM1 8V7.5V8ZM1 1.5V1V1.5ZM14 4.75V4.25V4.75ZM14 8V7.5V8ZM14 1.5V1V1.5ZM14 8H13.5H14ZM1.5 8H1H1.5ZM1.5 1H1H1.5ZM4.5 1H4H4.5ZM7.75 1H7.25H7.75ZM7.75 8H7.25H7.75ZM11 1H10.5H11ZM4.5 8H4H4.5ZM11 8H10.5H11ZM14 1H13.5H14Z"
            fill="#D9D9D9"
          />
          <path
            d="M3 12V15.5H7M1 4.75V4.25M1 7.5V8H1.5M1 1.5V1H1.5M14 4.75V4.25M14 7.5V8H13.5M14 1.5V1H13.5M4.5 1H4M7.75 1H7.25M7.75 8H7.25M11 1H10.5M4.5 8H4M11 8H10.5M7 12H19V19H7V12Z"
            stroke="#474747"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      )}
    </SvgWrapper>
  );
};
const SublimitCategoryIcon = ({
  width,
  height,
  className,
  onClick,
  color,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '20'}
      height={height ? height : '21'}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77807 9.48147L9.48177 0.148132L15.1855 9.48147H3.77807ZM15.1855 20.8889C13.8892 20.8889 12.7875 20.4353 11.8804 19.5283C10.9734 18.6212 10.5195 17.5192 10.5188 16.2222C10.5181 14.9252 10.972 13.8235 11.8804 12.9172C12.7889 12.0108 13.8906 11.5569 15.1855 11.5555C16.4804 11.5542 17.5824 12.008 18.4916 12.9172C19.4007 13.8263 19.8542 14.928 19.8521 16.2222C19.8501 17.5164 19.3965 18.6185 18.4916 19.5283C17.5866 20.4381 16.4845 20.8916 15.1855 20.8889ZM0.148438 20.3704V12.0741H8.44473V20.3704H0.148438ZM15.1855 18.8148C15.9114 18.8148 16.525 18.5642 17.0262 18.0629C17.5275 17.5617 17.7781 16.9481 17.7781 16.2222C17.7781 15.4963 17.5275 14.8827 17.0262 14.3815C16.525 13.8802 15.9114 13.6296 15.1855 13.6296C14.4595 13.6296 13.846 13.8802 13.3447 14.3815C12.8435 14.8827 12.5929 15.4963 12.5929 16.2222C12.5929 16.9481 12.8435 17.5617 13.3447 18.0629C13.846 18.5642 14.4595 18.8148 15.1855 18.8148ZM2.22251 18.2963H6.37066V14.1481H2.22251V18.2963ZM7.45955 7.40739H11.504L9.48177 4.14072L7.45955 7.40739Z"
        fill={color ?? '#474747'}
      />
    </SvgWrapper>
  );
};

const DocCategoryIcon = ({
  width,
  height,
  className,
  onClick,
  color,
  mobileActive,
}: svgProps & {
  mobileActive?: boolean;
}) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '17'}
      height={height ? height : '19'}
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {mobileActive ? (
        <path
          d="M14.5191 5.57031H14.538L14.5247 5.55698L11.1305 2.16285L11.1172 2.14951V2.16838V5.5625H11.125V5.57031H14.5191ZM15.0625 6.86719H9.82031V1.625H9.8125V1.61719H1.9375V1.625H1.92969V17.375H1.9375V17.3828H15.0625V17.375H15.0703V6.875H15.0625V6.86719ZM1.28125 0.320312H11.1218L16.3672 5.56574V18.0312C16.3672 18.2032 16.2989 18.3682 16.1773 18.4898C16.0557 18.6114 15.8907 18.6797 15.7188 18.6797H1.28125C1.10927 18.6797 0.944341 18.6114 0.822736 18.4898C0.70113 18.3682 0.632812 18.2032 0.632812 18.0312V0.96875C0.632812 0.796774 0.70113 0.631841 0.822736 0.510235C0.944341 0.38863 1.10927 0.320312 1.28125 0.320312ZM4.57031 9.50781H12.4297V10.8047H4.57031V9.50781ZM4.57031 5.57031H7.83594V6.86719H4.57031V5.57031ZM4.57031 13.4453H12.4297V14.7422H4.57031V13.4453Z"
          fill="white"
          stroke="black"
          stroke-width="0.015625"
        />
      ) : (
        <path
          d="M14.5191 5.57031H14.538L14.5247 5.55698L11.1305 2.16285L11.1172 2.14951V2.16838V5.5625H11.125V5.57031H14.5191ZM15.0625 6.86719H9.82031V1.625H9.8125V1.61719H1.9375V1.625H1.92969V17.375H1.9375V17.3828H15.0625V17.375H15.0703V6.875H15.0625V6.86719ZM1.28125 0.320312H11.1218L16.3672 5.56574V18.0312C16.3672 18.2032 16.2989 18.3682 16.1773 18.4898C16.0557 18.6114 15.8907 18.6797 15.7188 18.6797H1.28125C1.10927 18.6797 0.944341 18.6114 0.822736 18.4898C0.70113 18.3682 0.632812 18.2032 0.632812 18.0312V0.96875C0.632812 0.796774 0.70113 0.631841 0.822736 0.510235C0.944341 0.38863 1.10927 0.320312 1.28125 0.320312ZM4.57031 9.50781H12.4297V10.8047H4.57031V9.50781ZM4.57031 5.57031H7.83594V6.86719H4.57031V5.57031ZM4.57031 13.4453H12.4297V14.7422H4.57031V13.4453Z"
          fill="#474747"
          stroke="#474747"
          stroke-width="0.015625"
        />
      )}
    </SvgWrapper>
  );
};

const LoanTypeIcon = ({
  width,
  height,
  className,
  color,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '22'}
      height={height ? height : '22'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3125 15.125L9.34313 16.0944L11.1169 17.875H2.75V5.5H1.375V17.875C1.375 18.6333 1.99169 19.25 2.75 19.25H11.1169L9.34313 21.0306L10.3125 22L13.75 18.5625L10.3125 15.125Z"
        fill={color ?? '#474747'}
      />
      <path
        d="M7.5625 11.6875C7.9422 11.6875 8.25 11.3797 8.25 11C8.25 10.6203 7.9422 10.3125 7.5625 10.3125C7.1828 10.3125 6.875 10.6203 6.875 11C6.875 11.3797 7.1828 11.6875 7.5625 11.6875Z"
        fill={color ?? '#474747'}
      />
      <path
        d="M16.5 13.75H5.5C4.74169 13.75 4.125 13.1333 4.125 12.375V9.625C4.125 8.86669 4.74169 8.25 5.5 8.25H16.5C17.2583 8.25 17.875 8.86669 17.875 9.625V12.375C17.875 13.1333 17.2583 13.75 16.5 13.75ZM5.5 9.625V12.375H16.5V9.625H5.5Z"
        fill={color ?? '#474747'}
      />
      <path
        d="M19.25 2.75H10.8831L12.6569 0.969375L11.6875 0L8.25 3.4375L11.6875 6.875L12.6569 5.90563L10.8831 4.125H19.25V16.5H20.625V4.125C20.625 3.36737 20.0083 2.75 19.25 2.75Z"
        fill={color ?? '#474747'}
      />
    </SvgWrapper>
  );
};

const SearchIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '14'}
      height={height ? height : '14'}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 13L9 9M10.3333 5.66667C10.3333 8.244 8.244 10.3333 5.66667 10.3333C3.08934 10.3333 1 8.244 1 5.66667C1 3.08934 3.08934 1 5.66667 1C8.244 1 10.3333 3.08934 10.3333 5.66667Z"
        stroke="#A1A1AA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};

const VendorIcon = ({ width, height, className, color, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '19'}
      height={height ? height : '19'}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2135_12586)">
        <g clip-path="url(#clip1_2135_12586)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.6878 5.7H7.11313C6.75629 5.70002 6.40404 5.78045 6.08255 5.93532C5.76107 6.09019 5.47861 6.3155 5.25617 6.59453C5.03373 6.87356 4.87703 7.19913 4.79771 7.54704C4.71838 7.89496 4.71847 8.25627 4.79798 8.60415L5.66533 12.4041C5.78521 12.9287 6.07965 13.397 6.50042 13.7323C6.9212 14.0677 7.44337 14.2502 7.98143 14.25H14.8205C15.3584 14.25 15.8803 14.0673 16.3009 13.732C16.7215 13.3967 17.0158 12.9285 17.1356 12.4041L18.003 8.60415C18.0825 8.25627 18.0826 7.89496 18.0033 7.54704C17.9239 7.19913 17.7672 6.87356 17.5448 6.59453C17.3223 6.3155 17.0399 6.09019 16.7184 5.93532C16.3969 5.78045 16.0447 5.70002 15.6878 5.7ZM7.00768 7.61235C7.04226 7.6043 7.07763 7.60016 7.11313 7.6H15.6878C15.7591 7.60007 15.8295 7.61619 15.8937 7.64717C15.9579 7.67815 16.0143 7.72318 16.0588 7.77893C16.1032 7.83469 16.1345 7.89973 16.1504 7.96924C16.1663 8.03874 16.1663 8.11093 16.1505 8.18045L15.2831 11.9804C15.2592 12.0853 15.2005 12.179 15.1164 12.2461C15.0324 12.3133 14.928 12.3499 14.8205 12.35H7.98048C7.87291 12.3499 7.76857 12.3133 7.68452 12.2461C7.60048 12.179 7.54171 12.0853 7.51783 11.9804L6.65048 8.18045C6.62265 8.05775 6.64462 7.92903 6.71159 7.82253C6.77856 7.71602 6.88504 7.64043 7.00768 7.61235Z"
            fill={color ?? '#474747'}
          />
          <path
            d="M3.3157 1.9H1.9002C1.64824 1.9 1.4066 1.79991 1.22844 1.62175C1.05028 1.44359 0.950195 1.20196 0.950195 0.95C0.950195 0.698044 1.05028 0.456408 1.22844 0.278249C1.4066 0.100089 1.64824 0 1.9002 0L4.0757 0C4.29125 0.000107756 4.50036 0.0735184 4.66868 0.208175C4.837 0.342831 4.95452 0.530726 5.00195 0.741L7.57645 12.141C7.60832 12.2642 7.61511 12.3925 7.59643 12.5184C7.57775 12.6443 7.53397 12.7651 7.46768 12.8738C7.4014 12.9824 7.31397 13.0766 7.21059 13.1508C7.1072 13.225 6.98996 13.2776 6.86583 13.3056C6.74169 13.3336 6.6132 13.3364 6.48797 13.3138C6.36274 13.2912 6.24333 13.2437 6.13683 13.1741C6.03032 13.1044 5.93889 13.0141 5.86797 12.9084C5.79704 12.8028 5.74806 12.6839 5.72395 12.559L3.3157 1.9ZM9.5002 16.3875C9.5002 16.6058 9.45719 16.822 9.37364 17.0237C9.2901 17.2254 9.16764 17.4087 9.01326 17.5631C8.85888 17.7174 8.67561 17.8399 8.47391 17.9234C8.2722 18.007 8.05602 18.05 7.8377 18.05C7.61937 18.05 7.40319 18.007 7.20148 17.9234C6.99978 17.8399 6.81651 17.7174 6.66213 17.5631C6.50775 17.4087 6.38529 17.2254 6.30175 17.0237C6.2182 16.822 6.1752 16.6058 6.1752 16.3875C6.1752 15.9466 6.35035 15.5237 6.66213 15.2119C6.97391 14.9002 7.39677 14.725 7.8377 14.725C8.27862 14.725 8.70148 14.9002 9.01326 15.2119C9.32504 15.5237 9.5002 15.9466 9.5002 16.3875ZM16.1502 16.3875C16.1502 16.8284 15.975 17.2513 15.6633 17.5631C15.3515 17.8748 14.9286 18.05 14.4877 18.05C14.0468 18.05 13.6239 17.8748 13.3121 17.5631C13.0004 17.2513 12.8252 16.8284 12.8252 16.3875C12.8252 15.9466 13.0004 15.5237 13.3121 15.2119C13.6239 14.9002 14.0468 14.725 14.4877 14.725C14.9286 14.725 15.3515 14.9002 15.6633 15.2119C15.975 15.5237 16.1502 15.9466 16.1502 16.3875Z"
            fill={color ?? '#474747'}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2135_12586">
          <rect width="19" height="19" fill="white" />
        </clipPath>
        <clipPath id="clip1_2135_12586">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </SvgWrapper>
  );
};

const LCTypeIcon = ({ width, height, className, color, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '19'}
      height={height ? height : '19'}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="url(#pattern0_100_2)" />
      <defs>
        <pattern
          id="pattern0_100_2"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_100_2" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_100_2"
          width="90"
          height="90"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADa0lEQVR4nO2cPW8TQRCGF8SHAhI0FCQUVFBBFSFEgdLcve/acQHFtZT8BEIDJjQECUEDBS0lLWUaEB8RJaLgKyWEglAQgUQAYTRSQJGVOCFe386u55GmsUa+nWfXe+v1+pwzDMMwDMMwVtFsNg8CuE3yswSAOyRHV+cYfVCW5V4AUwC+kOysDgDfSM4URbG/n2sMNRMTEzsAnAfwsVvwGrEoneG93x273UlBsiD5chOCu0f4G+995ZzbFrsG1ZRleZLko/8VvEY8995PxK5HHY1G4yiA+yR/B5C8eoTPNhqN427YabVaB+RmBmA5pOCu+Eny7lCuUMoeK4kBxlfpVO/9Ppc77XZ7O4BzABZqFNw9nXySTq6qapfLEQBnSL7qQ5BMLxeKohiTWPlEbHnKAfDae3/W5QLJUwAeBxiJU93vLa8FGOVPpI0uVQawkhhd62t5wClltizLYy7BlcT3kHNrURRj3deanJw8NIgVinSg07ySIHkJwFLg4js9po6LA7rWEoDLUpNTuCcx0JUEgGWRHepmuMlrLkhtUmP0PQkALwZZLBXEygql/j0U7/0JAA9jC2D9wudInh644GazeRjAvdB7EkwvHhRFcSS4YPkWRfIWyR8KiuwoCXFxc3x8fGcw0fKGCgrrKI0bIUUvKiioozFk7ySk6A+xC6LSAPA+pOiZ2AVRb1wLfTMU2Tay+S/ExUzt263rNSjX/GhoE0ETnUd+NLSJoInOIz8a2kTQROeRHw1tImii88iPhjYRNNF55EdDmwia6Dzyo6FNBE10HvnR0CaCJjqP/GhoE0ETnUd+NLSJoInOIz8a2kTQROeRHw1tImiiEytMGya6Jkx0TZjomjDRNWGiAyPHVAFcr/sJBa4HrVZrD4CrAOYB/KqzXWuFtEHaQnK6qqqRpA6lu96S52LL7SH92ZZkxzqM7tZBRnJsmZuIKzmInlcgcqN4l/zUAQVz8kYhbUzm/yxu/Y6PLrKf9huGYRiGYWS+p8FhW95p+6O9y1W0lpHM3EVre5KBy1i0TR2sQbS2Z3S4XEWnAhVINNHUEy51qECiiaaecKlDBRJNNPWESx0qkDgUopHrj7PaQBrHDd661CE5ncCIbrvUqapqRI5dxZbZI55u+fydNqqqGpFjV3IiSMOcvdIGaUv7r+Q/ClENfPwzLyMAAAAASUVORK5CYII="
        />
      </defs>
    </SvgWrapper>
  );
};

const NotificationIcon = ({
  width,
  height,
  className,
  onClick,
  isTrue,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '28'}
      height={height ? height : '28'}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0004 22.75C14.9629 22.75 15.7504 21.9625 15.7504 21H12.2504C12.2504 21.9625 13.0292 22.75 14.0004 22.75ZM19.2504 17.5V13.125C19.2504 10.4388 17.8154 8.19 15.3129 7.595V7C15.3129 6.27375 14.7267 5.6875 14.0004 5.6875C13.2742 5.6875 12.6879 6.27375 12.6879 7V7.595C10.1767 8.19 8.75044 10.43 8.75044 13.125V17.5L7.62172 18.6288C7.07047 19.18 7.45547 20.125 8.23422 20.125H19.7579C20.5367 20.125 20.9304 19.18 20.3792 18.6288L19.2504 17.5Z"
        fill="#333342"
      />
      {isTrue && (
        <path
          d="M20.125 12.25C22.5412 12.25 24.5 10.2912 24.5 7.875C24.5 5.45876 22.5412 3.5 20.125 3.5C17.7088 3.5 15.75 5.45876 15.75 7.875C15.75 10.2912 17.7088 12.25 20.125 12.25Z"
          fill="#ED3A3A"
        />
      )}
    </SvgWrapper>
  );
};
const NotificationActionIcon = ({
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '8'}
      height={height ? height : '12'}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6583_10942"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="8"
        height="12"
      >
        <path
          d="M7.25 2H0.75C0.473858 2 0.25 2.22386 0.25 2.5V10.5C0.25 10.7761 0.473858 11 0.75 11H7.25C7.52614 11 7.75 10.7761 7.75 10.5V2.5C7.75 2.22386 7.52614 2 7.25 2Z"
          fill="white"
          stroke="white"
          stroke-width="0.5"
          stroke-linejoin="round"
        />
        <path
          d="M2.5 1V2.5M5.5 1V2.5"
          stroke="white"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 4.75H6M2 6.75H5M2 8.75H4"
          stroke="black"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_6583_10942)">
        <path d="M-2 0H10V12H-2V0Z" fill="#A5A4A1" />
      </g>
    </SvgWrapper>
  );
};

const NotificationHomeIcon = ({
  width,
  height,
  className,
  onClick,
}: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '12'}
      height={height ? height : '11'}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.69421 10.3395V7.03723H7.30289V10.3395C7.30289 10.7028 7.59636 11 7.95506 11H9.91156C10.2703 11 10.5637 10.7028 10.5637 10.3395V5.7163H11.6724C11.9724 5.7163 12.1159 5.33984 11.8876 5.1417L6.4355 0.168418C6.18768 -0.0561393 5.80942 -0.0561393 5.5616 0.168418L0.109468 5.1417C-0.11227 5.33984 0.0246858 5.7163 0.324683 5.7163H1.43337V10.3395C1.43337 10.7028 1.72685 11 2.08554 11H4.04204C4.40074 11 4.69421 10.7028 4.69421 10.3395Z"
        fill="black"
      />
    </SvgWrapper>
  );
};
const PngIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    style={{ minWidth: width }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.0234 1.5V5.90475H22.2482L18.0234 1.5Z" fill="#F4F4F4" />
    <path d="M17.9688 1.5625V5.96725H22.1935L17.9688 1.5625Z" fill="#909090" />
    <path
      d="M18.0266 1.5H6.60938V22.446H22.2514V5.90475L18.0266 1.5Z"
      fill="#F4F4F4"
    />
    <path
      d="M18.072 1.55469L22.245 5.90469V22.4467H6.65625V22.5007H22.2983V5.95944L18.072 1.55469Z"
      fill="#909090"
    />
    <rect
      x="1.5"
      y="2.625"
      width="15.375"
      height="5.25"
      rx="0.375"
      fill="#2196F3"
    />
    <path
      d="M4.875 3.375H3.75V6.75H4.5V5.625H4.875C5.07391 5.625 5.26468 5.54598 5.40533 5.40533C5.54598 5.26468 5.625 5.07391 5.625 4.875V4.125C5.625 3.92609 5.54598 3.73532 5.40533 3.59467C5.26468 3.45402 5.07391 3.375 4.875 3.375ZM4.875 4.875H4.5V4.125H4.875V4.875Z"
      fill="white"
    />
    <path
      d="M8.25 3.375H7.5V6.75H8.25V4.875L9.375 6.75H10.125V3.375H9.375V5.25L8.25 3.375Z"
      fill="white"
    />
    <path
      d="M12.375 3.375H11.25C11.0511 3.375 10.8603 3.45402 10.7197 3.59467C10.579 3.73532 10.5 3.92609 10.5 4.125V6C10.5 6.19891 10.579 6.38968 10.7197 6.53033C10.8603 6.67098 11.0511 6.75 11.25 6.75H12.375V5.25H11.625V6H11.25V4.125H12.375V5.25H13.125V4.125C13.125 3.92609 13.046 3.73532 12.9053 3.59467C12.7647 3.45402 12.5739 3.375 12.375 3.375Z"
      fill="white"
    />
    <path
      d="M8.25 10.5C8.25 11.3284 7.57843 12 6.75 12C5.92157 12 5.25 11.3284 5.25 10.5C5.25 9.67157 5.92157 9 6.75 9C7.57843 9 8.25 9.67157 8.25 10.5Z"
      fill="#2196F3"
    />
    <path
      d="M4.5 18.75L7.5 13.5L10.5 18L12.75 15L16.5 18.75H4.5Z"
      fill="#2196F3"
    />
  </svg>
);

const DownloadIcon = ({ width, height, className, onClick }: svgProps) => {
  return (
    <SvgWrapper
      onClick={onClick}
      className={`${className}`}
      width={width ? width : '14'}
      height={height ? height : '14'}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.254 8.75V11.0842C12.254 11.3938 12.1311 11.6906 11.9122 11.9095C11.6933 12.1284 11.3965 12.2513 11.0869 12.2513H2.91712C2.60758 12.2513 2.31072 12.1284 2.09184 11.9095C1.87296 11.6906 1.75 11.3938 1.75 11.0842V8.75"
        stroke="#0F172A"
        stroke-width="1.16712"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.08203 5.82812L6.99982 8.74592L9.91761 5.82812"
        stroke="#0F172A"
        stroke-width="1.16712"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.00012 8.7527V1.75"
        stroke="#0F172A"
        stroke-width="1.16712"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgWrapper>
  );
};

export {
  ExportIcon,
  PlusIcon,
  UploadIcon,
  ConvertIcon,
  DocumentIcon,
  FileIcon,
  FileIconV2,
  DocumentIconV2,
  CloseIcon,
  WarningIcon,
  CaretIcon,
  ArrowRight,
  CircleDotIcon,
  GridExpandIcon,
  GridSortIcon,
  GridToggleIcon,
  NoDataFoundIcon,
  BackIcon,
  EditIcon,
  DeleteIcon,
  MobileBackIcon,
  PrevArrowIcon,
  NextArrowIcon,
  DropdownArrowIcon,
  DropdownCloseIcon,
  WordIcon,
  PdfIcon,
  ExcelIcon,
  FloatingButtonIcon,
  HistoryDotIcon,
  RightCaretArrow,
  RedWarningIcon,
  FileUploadTypeIcon,
  WarningCloseIcon,
  RightCaretIcon,
  SplitMoreIcon,
  SplitMoreMobileIcon,
  SplitRemoveMobileIcon,
  BankIcon,
  SublimitTypeIcon,
  SublimitCategoryIcon,
  DocCategoryIcon,
  LoanTypeIcon,
  SearchIcon,
  VendorIcon,
  NotificationIcon,
  NotificationActionIcon,
  NotificationHomeIcon,
  LCTypeIcon,
  PngIcon,
  DownloadIcon,
};
